import React, { createContext, useReducer, useEffect } from "react";
import Reducer from "./Reducer"

const initialState = {
    portfolio: localStorage.getItem("portfolio")
      ? JSON.parse(localStorage.getItem("portfolio"))
      : [],
  };

  export const GlobalContext = createContext(initialState);

export const GlobalProvider = (props) => {
    const [state, dispatch] = useReducer(Reducer, initialState);

    useEffect(() => {
        localStorage.setItem("portfolio", JSON.stringify(state.portfolio));
      }, [state]);
    
      const addTokenToPortfolio = (token) => {
        dispatch({ type: "ADD_TOKEN_TO_PORTFOLIO", payload: token });
      };
    
      const removeTokenFromPortfolio = (id) => {
        dispatch({ type: "REMOVE_TOKEN_FROM_PORTFOLIO", payload: id });
      };
    
      return (
        <GlobalContext.Provider
          value={{
            portfolio: state.portfolio,
            addTokenToPortfolio,
            removeTokenFromPortfolio,
          }}
        >
          {props.children}
        </GlobalContext.Provider>
      );
    };